import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getFhirJson = async (foi = null, fli = null, apiToken = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    console.log("CALLING SERVER with getresourcejson")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getresourcejson",
            "resourceid": foi,
            "apiToken": apiToken,
            "fli": fli
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is Resource JSON as an object
            return resp.data;
        }
        console.log("NO RESPONSE from getresourcejson call");
    }).catch((error) => { console.log(error); });
};

export default getFhirJson;